import { render, staticRenderFns } from "./EbooksDetail.vue?vue&type=template&id=22c696cb&scoped=true&"
import script from "./EbooksDetail.vue?vue&type=script&lang=js&"
export * from "./EbooksDetail.vue?vue&type=script&lang=js&"
import style0 from "./EbooksDetail.vue?vue&type=style&index=0&id=22c696cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c696cb",
  null
  
)

export default component.exports